import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import Photo from "../components/Photo";
import "./blogPage.css";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const BlogPage = () => {
  const { link } = useParams();
  const [blog, setBlog] = useState(null);
  const [prevBlog, setPrevBlog] = useState(null);
  const [nextBlog, setNextBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [apiUrl, setApiUrl] = useState("");

  useEffect(() => {
    const fetchApiUrl = async () => {
      try {
        const response = await axios.get("/templates/api.txt");
        setApiUrl(response.data.trim());
      } catch (err) {
        console.error("Ошибка при загрузке API URL:", err);
        setError("Ошибка загрузки данных");
      }
    };
    fetchApiUrl();
  }, []);

  useEffect(() => {
    const fetchBlogData = async () => {
      if (!apiUrl) return;

      try {
        const [blogRes, neighborsRes] = await Promise.all([
          axios.get(`${apiUrl}api/blogs/${link}`),
          axios.get(`${apiUrl}api/blogs/${link}/neighbors`),
        ]);

        if (blogRes.data) {
          setBlog(blogRes.data);
          setPrevBlog(neighborsRes.data.prev);
          setNextBlog(neighborsRes.data.next);
        } else {
          setError("Блог не найден");
        }
      } catch (err) {
        setError("Ошибка загрузки блога");
        console.error("Ошибка:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogData();
  }, [apiUrl, link]);

  if (loading) {
    return <div className="loading"></div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!blog) {
    return <div className="error">Блог не найден</div>;
  }

  return (
    <div className="blog-page">
      <Helmet>
        <title data-react-helmet="true">{blog.title} | Nicotine Club</title>
        <meta
          data-react-helmet="true"
          name="description"
          content={blog.description}
        />
        <meta
          data-react-helmet="true"
          name="keywords"
          content={blog.keywords || ""}
        />
      </Helmet>

      <article className="blog-article">
        <header className="blog-header">
          <div className="blog-flex-button">
            <Link to="/blogs" className="exit-button">
              <FiChevronLeft className="nav-icon" />
            </Link>
            <h1 className="blog-title">{blog.title}</h1>
          </div>
          <div className="blog-meta">
            Дата публикации:{" "}
            <time className="blog-date">
              {new Date(blog.created_at).toLocaleDateString("ru-RU", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </time>
          </div>
          <Photo
            src={`${apiUrl}img/${blog.img_url}`}
            alt={blog.title}
            className="blog-main-image"
          />
        </header>

        <div className="blog-content">
          <div
            className="blog-html-content"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />
        </div>

        <footer className="blog-footer">
          <div className="blog-tags">
            {blog.keywords?.split(", ").map((keyword, index) => (
              <span key={index} className="blog-tag">
                #{keyword}
              </span>
            ))}
          </div>
        </footer>
      </article>
      <div>
        <h2 className="blog-block">Больше статей блога</h2>
        <div className="blog-navigation">
          {prevBlog && (
            <Link to={`/blogs/${prevBlog.link}`} className="nav-button prev">
              <FiChevronLeft className="nav-icon" />
              <div className="nav-content">
                <span className="nav-label">Предыдущая статья</span>
                <Photo
                  src={`${apiUrl}img/${prevBlog.img_url}`}
                  alt={prevBlog.title}
                  className="nav-image"
                />
                <h3 className="nav-title">{prevBlog.title}</h3>
              </div>
            </Link>
          )}

          {nextBlog && (
            <Link to={`/blogs/${nextBlog.link}`} className="nav-button next">
              <div className="nav-content">
                <span className="nav-label">Следующая статья</span>
                <Photo
                  src={`${apiUrl}img/${nextBlog.img_url}`}
                  alt={nextBlog.title}
                  className="nav-image"
                />
                <h3 className="nav-title">{nextBlog.title}</h3>
              </div>
              <FiChevronRight className="nav-icon" />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
